import { endOfMonth, getDate, isSameMonth, isSameYear } from 'date-fns';

const safeFormatRange = (formatter: Intl.DateTimeFormat, start: Date, end: Date) => {
	// formatRange isn't supported in some older browsers; fall back gracefully.
	const anyFormatter = formatter as unknown as { formatRange?: (start: Date, end: Date) => string };
	if (typeof anyFormatter.formatRange === 'function') {
		return anyFormatter.formatRange(start, end);
	}
	return `${formatter.format(start)}–${formatter.format(end)}`;
};

/**
 * Locale-aware date range formatting for Spotlight.
 *
 * Uses month/year-only when the dates are month boundaries, otherwise includes day.
 */
export const formatUserSpotlightDateRange = (startTime: Date, endTime: Date, locale?: string): string => {
	const isStartFirstOfMonth = getDate(startTime) === 1;
	const isEndLastOfMonth = getDate(endTime) === getDate(endOfMonth(endTime));
	const lng = locale || undefined;

	if (isStartFirstOfMonth && isEndLastOfMonth) {
		const monthYear = new Intl.DateTimeFormat(lng, { month: 'short', year: 'numeric' });
		if (isSameMonth(startTime, endTime)) {
			return monthYear.format(startTime);
		}
		return safeFormatRange(monthYear, startTime, endTime);
	}

	// Otherwise show full dates
	const monthDayYear = new Intl.DateTimeFormat(lng, { month: 'short', day: 'numeric', year: 'numeric' });
	if (isSameYear(startTime, endTime)) {
		return safeFormatRange(monthDayYear, startTime, endTime);
	}
	return safeFormatRange(monthDayYear, startTime, endTime);
};
